export enum UiEventsEmit {
  CloseMagicWindow = 'close-magic-window',
}
